import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

/**
 * Angular CDK 21 renders overlays through the native Popover API by default: the overlay host
 * gets `popover="manual"` and is promoted to the browser's top layer, where it paints above the
 * entire DOM regardless of `z-index`. `ng-select` panels appended to `body` (`appendTo="body"`,
 * e.g. `fr8bot-ui-select-field`) still stack via `z-index: 1050` in normal
 * flow, so when they're opened inside a CDK overlay (a dialog) they end up hidden behind it with
 * no console error. Opting back into the pre-CDK-21 z-index-based stacking model fixes this.
 *
 * ng-select 24 changed the ground under this: the panel is now a CDK overlay of its own and the
 * hardcoded `z-index: 1050` is gone, so a panel opened inside a dialog stacks as a sibling
 * overlay created later. The compat flag is kept because it still produces the correct result
 * (see the `Molecules/Select` → `InsideDialog` story) and because dropping it changes stacking
 * for every overlay in the app, not just these panels — that is its own scoped task, with the
 * re-check list in `docs/plans/20260819-164721-fr8bot-1048-…`.
 */
export const provideOverlayCompat = () => ({
  provide: OVERLAY_DEFAULT_CONFIG,
  useValue: { usePopover: false },
});
